import React, { useContext, useEffect, useState } from "react";
import { MyContext } from "../../globalContext";
import { fetchContentFromAzureBlobStorage } from '../../data/Contentapi';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import PropTypes from "prop-types";
import { CircularProgress } from '@mui/material';


const NewYorkHospitalBased = ({searchResultsProp}) => {   
    const [showDownloadProgress, setShowDownloadProgress] = useState(false);
    const { t } = useTranslation();
    const { languageData } = useContext(MyContext);
    const [isBehavioralHealth, setisBehavioralHealth] = useState([]);
    const [resultState, setResultState]= useState([]);


    useEffect(() => {
     setisBehavioralHealth(searchResultsProp && searchResultsProp[0]?.provider?.providerDetails?.practitioner?.isBehavioralHealth);
     setResultState(searchResultsProp && searchResultsProp[0]?.provider?.officeList?.office[0]?.address?.domesticAddress?.state?.stateAbbreviation);

    },[]);

    const getNYHospitalBasedPdf = async (event) => {
        try {   
            event.preventDefault();
            setShowDownloadProgress(true);        
            const response = await fetchContentFromAzureBlobStorage(
                languageData.toLowerCase(),
                "Disclaimers",
                "NY_MENTAL_HEALTH.pdf"
            );
            console.log('Response got');

            const url = window.URL.createObjectURL(convertToBlob(response));
            const a = document.createElement('a');
            a.href = url;
            a.download = 'NY_MENTAL_HEALTH.pdf'; 
            document.body.appendChild(a);
            a.click();
            a.remove();
            window.URL.revokeObjectURL(url);
            setShowDownloadProgress(false);

        } catch (error) {
            setShowDownloadProgress(false);
            console.error('Error downloading the PDF:', error);
        }




    };
    const convertToBlob = (response) => {
        if (response) {

            const imageString = response.imageString; 
            const byteCharacters = atob(imageString); 
            const byteNumbers = new Array(byteCharacters.length);

            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }

            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray], { type: 'application/pdf' }); 
            return blob;
        }

    }

    return (
        <Box sx={{ width: "99%" }} >   
    
      {isBehavioralHealth && isBehavioralHealth == true && resultState && resultState == "NY" && 
            <div className="alignLink">
                <span><a href="#" onClick={getNYHospitalBasedPdf} className="results-link Cp"><b> {t(`Here`)} </b></a> {t(`HereContentNY`)} {showDownloadProgress && <CircularProgress data-testid='loading-circle' color="primary" style={{ verticalAlign: "middle", width: '20px', height: '20px', marginLeft:"5px" }}  />} </span>
            </div>
}
        

        </Box>
    )
};

NewYorkHospitalBased.propTypes = {    
    searchResultsProp: PropTypes.any
  
  };

export default NewYorkHospitalBased;